module.exports = __webpack_public_path__ + "img/acp.28255c7d.jpg";